"use client"

import { extractProperty } from "utils"
import LegalDisclaimer from "./LegalDisclaimer"
import ProductMainContent from "./ProductMainContent"
import RelatedProductsSection from "./RelatedProductsSection"

function ProductPage({
  locale,
  pageData,
  productsData,
  data,
  productCategories,
}: {
  locale: "he" | "en"
  pageData: any
  productsData?: any
  data: any
  productCategories?: any
}) {
  return (
    <>
      <ProductMainContent
        data={data}
        locale={locale}
        pageData={pageData}
        productCategories={productCategories}
      />
      <RelatedProductsSection
        data={extractProperty(pageData, "relatedProducts")?.[0]}
        productsData={productsData}
        locale={locale}
      />
      <LegalDisclaimer pageData={pageData} />
    </>
  )
}
export default ProductPage
